export default "Mairies & hôtels de ville — Collectivités | Solution Éco France";
